import React, { Component } from 'react';
import { connect } from 'react-redux';
import DashboardComponent from './Dashboard';
import { loggerEventOutcome, loggerEventTypes } from '../../helpers/messages';
import { logger } from '../../services/logger/logger-service';
import { applicationLogger, getRoleFromBackendAPI, handleADLogin } from '../../actions/loginAction';
import { Hub } from 'aws-amplify';
import { isFederatedCallback } from '../../helpers/GlobalFunctions';
let startDate;
class DashboardContainer extends Component {
	constructor() {
		super();
		this.handleCallbackURL();
		let eventName = "Dashboard";
		this.state = {
			eventName: eventName,
			loading: false,
			role: '',
			federatedLogin: isFederatedCallback(),
			roleError: null,
			loggerObj: {
				"EventOutcome": loggerEventOutcome.success,
				"EventType": loggerEventTypes.read,
				"EventName": eventName,
				"StartDate": new Date()
			}
		}
	}

	/**
	 * @description function to handle callback from federated login
	 * @param {*}
	 * @memberof DashboardContainer
	 */
	handleCallbackURL = () => {
		Hub.listen("auth", ({ payload: { event, data } }) => {
			switch (event) {
				case "cognitoHostedUI":
					handleADLogin(data);
					this.setState({ federatedLogin: true })
					getRoleFromBackendAPI().then((res) => {
						this.setState({ role: res.userRole })
					}).catch((err) => {
						this.setState({ role: 'noMappedGroup', roleError: err })
					});
					applicationLogger();
					break;
				case "cognitoHostedUI_failure":
					console.log('cognitoHostedUI_failure: ', { error: data });
					break;
				default:
					break;
			}
		});
	}

	componentDidMount() {
		// initialize the start date on page load
		startDate = new Date();
		window.addEventListener('beforeunload', this.applicationLogger);
	}

	componentWillUnmount() {
		window.removeEventListener('beforeunload', this.applicationLogger);
		this.applicationLogger();
	}

	/**
	 * @description function to handle application logs
	 * @param {*}
	 * @memberof DashboardContainer
	 */
	applicationLogger = (key) => {
		// calculate the time since we loaded this page
		const timeSinceLoad = (new Date().getTime() - startDate.getTime()) / 1000;
		const loggerObj = {
			"EventOutcome": loggerEventOutcome.success,
			"EventType": loggerEventTypes.read,
			"EventName": this.state.eventName,
			"Content": {
				"TimeSpent": timeSinceLoad
			}
		}
		logger(loggerObj);
	}

	render() {
		const {loading, loggerObj, role, federatedLogin } = this.state;
		return (
			<DashboardComponent
				loading={loading}
				role={role}
				federatedLogin={federatedLogin}
				loggerObj={loggerObj}
			/>
		);
	}
}

function mapStateToProps(state) {
	return {
		state,
	};
}

export default connect(mapStateToProps)(DashboardContainer);
